import DashboardLayout from "@/src/components/layout/DashboardLayout";
import StaticBlock from "@/src/modules/home/staticBlock";
import Announcements from "@/src/modules/home/announcements";
import PopularTests from "@/src/modules/home/popularTests";
import HealthPackages from "@/src/modules/home/healthPackages";

import Progressbar from "@/src/components/loading";
import HomeBlog from "@/src/modules/home/blogs";
import HomeFacilities from "@/src/modules/home/homeFacilities";
import Testimonials from "@/src/modules/home/testimonial";
import WhyCHooseUs from "@/src/modules/home/whyChooseUs";
import TechnologyPartners from "@/src/modules/home/technologyPartners";
import QuickAction from "@/src/modules/home/quickAction";
import useAuth from "@/src/lib/hooks/useAuth";
// import LoginPopUp from "@/src/components/common/loginPopUp";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { homeApiService } from "@/src/lib/api-services/homeApiServices";
import MobileApps from "@/src/modules/home/mobileApps";
import HomeSearch from "@/src/modules/home/homeSearch";
import dynamic from "next/dynamic";
import Head from "next/head";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
// import dynamic from "next/dynamic";

Home.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

// const HomeSearch = dynamic(() => import("@/src/modules/home/homeSearch"));
const LoginPopUp = dynamic(() => import("@/src/components/common/loginPopUp"));

export default function Home({ data }) {
    const { isLoggedIn } = useAuth();
    const [open, setOpen] = useState(false);
    const router = useRouter();
    const { query } = router;

    useEffect(() => {
        if (query.login === "true") {
            setOpen(true);
            router.replace(router.pathname, undefined, { shallow: true });
        }
    }, [query.login, router]);

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Head>
                <link
                    rel="preload"
                    href={`${NEXT_IMAGE_CDN}/web/home/banner/desktop/fever.webp`}
                    as="image"
                    type="image/webp"
                    crossOrigin="anonymous"
                />
                <link
                    rel="preload"
                    href={`${NEXT_IMAGE_CDN}/web/home/banner/desktop/hc-grey.webp`}
                    as="image"
                    type="image/webp"
                    crossOrigin="anonymous"
                />
            </Head>
            <HomeSearch />
            {isLoggedIn && <QuickAction />}
            <StaticBlock />
            <Announcements announcements={data?.announcements} />
            <PopularTests popularTests={data?.topProducts} />
            <HealthPackages healthPackages={data?.topPackage} />
            <HomeFacilities facilities={data?.categories} />
            <WhyCHooseUs />
            <TechnologyPartners />
            <Testimonials />
            <HomeBlog blogs={data?.blogs} />
            <MobileApps />

            <LoginPopUp
                setOpen={setOpen}
                open={open}
                onClose={onClose}
                title="Sign Up / Login"
            />
        </>
    );
}

export async function getServerSideProps() {
    let data = null;

    try {
        const response = await homeApiService.getHomeList();
        data = response?.data?.[0] || null;
    } catch (error) {
        console.error("Failed to fetch home data:", error);
    }

    return {
        props: {
            data: {
                ...data,
                seoTitle:
                    "HOD | House Of Diagnostics | Diagnostic Centre | Pathology Lab",
                seoDescription:
                    "HOD offers MRI, CT Scan, Xray, Path Lab, Ultrasound, Whole Body PET-CT, Full Body Checkup, Specialized Health Packages and other test for all your diagnostic needs.",
                routerPath: "",
            },
        },
    };
}
